import { Button, Modal, Row } from "react-bootstrap";

interface IProps {
    show: boolean,
    centerAlias: string,
    onUpdate: () => void,
    onCancel: () => void,
    currFeeValue: number,
    newFeeValue: number
}

const UpdateRmcrFeesModal = (props: IProps) => {
    return (
        <Modal bsSize='sm' show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                Update Rmcr Fee for {props.centerAlias}
            </Modal.Header>
            <Modal.Body>
                {`Are you sure you want to update the Actual RMCR Fee:`} <br /> <br />
                <Row style={{textAlign: "center"}}>
                    ${props.currFeeValue}{"   ->   "}${props.newFeeValue} ?
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onUpdate}>Update</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UpdateRmcrFeesModal;